/**
 * Auth hook, kept out of AuthContext.tsx.
 *
 * A module that exports both a component (AuthProvider) and a non-component
 * (this hook) cannot be hot-reloaded by Vite — every edit to the auth context
 * forced a full page reload, discarding wizard state.
 */
import { useContext } from 'react';
import { AuthContext, type AuthContextType } from './authContextDefinition';

export function useAuth(): AuthContextType {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
